module.exports = __webpack_public_path__ + "img/五人男篮.b5b2809c.png";